import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import url from 'libraries/front-end-core/core/url'
import { DOCUMENTS_ALL } from 'constants/controllers'
import { setDocumentKeyword, setDocumentShowAutomatedOnly, setDocumentShowFavouritesOnly } from 'redux/actions'
import Icon from 'components/shared/Icon'
import TiledMenuHeader from 'components/tiled-menu/Header'
import CompactSwitch from 'components/CompactSwitch'
import ReviewLink from './ReviewLink'

export default function PrecedentsMenuHeader ({ aol, view, isProxy = false }) {
  const dispatch = useDispatch()
  const keyword = useSelector(state => state.documents.keyword)
  const setKeyword = (val) => dispatch(setDocumentKeyword(val))
  const showFavouritesOnly = useSelector(state => state.documents.showFavouritesOnly)
  const setShowFavouritesOnly = (show) => dispatch(setDocumentShowFavouritesOnly(show))
  const showAutomatedOnly = useSelector(state => state.documents.showAutomatedOnly)

  return (
    <TiledMenuHeader
      title='Documents'
      keyword={keyword}
      setKeyword={setKeyword}
      showFavouritesOnly={showFavouritesOnly}
      setShowFavouritesOnly={setShowFavouritesOnly}
      childrenPosition='start'
      leftChildren={
        <div className='flex self-center ml8 mt2'>
          <a className='flex justify-center items-center mr4 no-underline' href={url(DOCUMENTS_ALL)}>
            <Icon name='icon-format-list-bulleted' className='w7 mr2' />
            View all
          </a>
          <ReviewLink />
        </div>
      }
    >
      <div>
        <CompactSwitch
          label={<span className='nowrap'>Automated only</span>}
          labelPlacement='end'
          checked={showAutomatedOnly}
          onChange={() => {
            dispatch(setDocumentShowAutomatedOnly(!showAutomatedOnly))
          }}
          data-event-category='Automated Documents'
          data-event-action={`Toggle-${showAutomatedOnly ? 'Off' : 'On'}`}
        />
      </div>
    </TiledMenuHeader>
  )
}
